import { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export const SurveyImport = ({ wo, onImported }) => {
  const [rows, setRows] = useState(null);
  const [sel, setSel] = useState("");
  const open = async () => {
    try { const { data } = await api.get(`/work-orders/${wo.id}/survey-sources`); setRows(data); setSel(data[0]?.id || ""); } catch (e) { toast.error(errMsg(e)); }
  };
  const run = async () => {
    try {
      const { data } = await api.post(`/work-orders/${wo.id}/import-survey`, { survey_id: sel });
      onImported(data.tech_data);
      toast.success(`Importado: ${data.cameras} cámara(s) y ${data.items} equipo(s) nuevos`);
      setRows(null);
    } catch (e) { toast.error(errMsg(e)); }
  };
  const imp = wo.tech_data?.vv_import;
  return (
    <div className="space-y-2 rounded-lg border border-dashed border-border p-3" data-testid="vv-survey-import">
      {imp && <p className="text-xs text-muted-foreground" data-testid="vv-survey-import-info">Datos recuperados del levantamiento {imp.survey_folio} (el levantamiento original no se modifica).</p>}
      {!rows && <Button size="sm" variant="outline" onClick={open} data-testid="vv-survey-import-open"><Download className="mr-1 h-4 w-4" />Importar cámaras y equipos desde levantamiento</Button>}
      {rows && !rows.length && <p className="text-sm text-muted-foreground" data-testid="vv-survey-import-empty">No hay levantamientos de Videovigilancia de este cliente. Registra los equipos y cámaras directamente.</p>}
      {rows?.length > 0 && <div className="flex flex-wrap gap-2">
        <select className="h-10 min-w-0 flex-1 rounded-md border border-border bg-transparent px-2 text-sm" value={sel} onChange={(e) => setSel(e.target.value)} data-testid="vv-survey-import-select">
          {rows.map((r) => <option key={r.id} value={r.id}>{r.folio} · {r.date}{r.linked ? " · ligado al proyecto" : ""}{r.address ? ` · ${r.address}` : ""}</option>)}
        </select>
        <Button size="sm" onClick={run} disabled={!sel} data-testid="vv-survey-import-run">Importar</Button>
      </div>}
    </div>
  );
};
